module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-msg"
  }, [_c('div', {
    staticClass: "weui-msg__icon-area"
  }, [_c('i', {
    staticClass: "weui-icon_msg",
    class: ("weui-icon-" + (_vm.icon || 'success'))
  })]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__text-area"
  }, [_c('h2', {
    staticClass: "weui-msg__title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-msg__desc"
  }, [_vm._t("description")], 2), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "weui-msg__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "weui-msg__opr-area"
  }, [_c('p', {
    staticClass: "weui-btn-area"
  }, [_vm._t("buttons"), _vm._v(" "), _vm._l((_vm.buttons), function(button) {
    return _c('a', {
      staticClass: "weui-btn",
      class: ("weui-btn_" + (button.type)),
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.onClick(button.onClick, button.link)
        }
      }
    }, [_vm._v(_vm._s(button.text))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3780a21e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/msg/index.vue
// module id = 667
// module chunks = 0